import { DataBean } from "../DataBean";

export class CreditProcessMovement extends DataBean {


    public CUOTA_CREDITO = 100;
    public ABONO_CUOTA = 101;
    public MAYOR_VALOR = 102;
    public DETERIORO_CARTERA = 103;
    public CARTERA_VENCIDA = 104;
    public CENTRAL_RIESGO = 105;

    public OPERATION_TYPE = [
        { id: this.CUOTA_CREDITO, name: 'Cuenta Crobro Crédito' },
        { id: this.DETERIORO_CARTERA, name: 'Deterioro Cartera' },
        { id: this.MAYOR_VALOR, name: 'Mayores Valores' },
        { id: this.CARTERA_VENCIDA, name: 'Cartera Vencida' },
        // { id: this.CENTRAL_RIESGO, name: 'Central Riesgo' },
        // {id:this.MAYOR_VALOR,name:'Mayor Valor'}
    ]
    public CONCEPT_TYPE = [
        { id: 1001, name: 'CUENTA CUOTA CREDITO' },
        { id: 1001, name: 'INTERES CORRIENTE' },
        { id: 1001, name: 'INTERES MORA' },
        { id: 1001, name: 'FACTURACION CREDITO' },

    ]

    public async getCreditProcessMovementRender(page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getCreditProcessMovementRender_Number_Number_java.util.Map", [
            page, rows, props
        ]);
    }
    public async getCreditProcessItemRender(page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getCreditProcessItemRender_Number_Number_java.util.Map", [
            page, rows, props
        ]);
    }
    public async addCreditProcessMovement(idEmployee: number, operation: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.credit.bean.CreditProcessMovement_addCreditProcessMovement_Number_com.credit.bean.CreditProcessMovement", [
            idEmployee, operation
        ]);
    }
    public async getLoanLinePayrollFactorList(idCompany: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getLoanLinePayrollFactorList_Number", [
            idCompany
        ]);
    }
    public async getPayrollDeductionsForCreditQuota(year: number, month: number, idEmployee: number, idPayrollFactor: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollDeductionsForCreditQuota_Number_Number_Number_Number", [
            year, month, idEmployee, idPayrollFactor
        ]);
    }
    public async parseQuotaCredit(year: number, month: number, idPayrollFactor: number, idCustomProcessType: number, accountantDate: any, idBudgetAccountantOperation: number, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.Process_parseQuotaCredit_Number_Number_Number_Number_java.util.Date_Number_Number", [
            year, month, idPayrollFactor, idCustomProcessType, accountantDate, idBudgetAccountantOperation, idEmployee
        ]);
    }
    public async getCuotaByIDAccount(idAccount: number, idLoanLine: number, year: number, month: number, amount): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getCuotaByIDAccount_Number_Number_Number_Number_Number", [
            idAccount, idLoanLine, year, month, amount
        ]);
    }
    public async validarCuotasByNomina(year: number, month: number, idemployee: number, idPayrollFactor: number): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_validarCuotasByNomina_Number_Number_Number_Number", [
            year, month, idemployee, idPayrollFactor
        ]);
    }
    public async createQuotaCredit(accountantDate: any, idCreditProcessMovement: number, idBudgetAccountantOperation: number, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.Process_createQuotaCredit_java.util.Date_Number_Number_Number", [
            accountantDate, idCreditProcessMovement, idBudgetAccountantOperation, idEmployee
        ]);
    }
    public async createQuotaCreditThread(accountantDate: any, idCreditProcessMovement: number, idBudgetAccountantOperation: number, idEmployee: number): Promise<any> {
        return this.getCustomService("CreditCore", "void_createQuotaCreditThread_java.util.Date_Number_Number_Number", [
            accountantDate, idCreditProcessMovement, idBudgetAccountantOperation, idEmployee
        ]);
    }
    public async createQuotaCredit2(accountantDate: any, year: number, month: number, idLoanLine: number | null, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.Process_createQuotaCredit_java.util.Date_Number_Number_Number_Number", [
            accountantDate, year, month, idLoanLine, idEmployee
        ]);
    }
    public async removeCreditProcessMovement(idCreditProcessMovement: number): Promise<any> {
        return this.getCustomService("CreditCore", "Boolean_removeCreditProcessMovement_Number", [
            idCreditProcessMovement
        ]);
    }
    public async recalcularCuota(idCreditProcessMovement: number, idCreditAccount: number): Promise<any> {
        return this.getCustomService("CreditCore", "com.credit.bean.CreditProcessItem_recalcularCuota_Number_Number", [
            idCreditProcessMovement, idCreditAccount
        ]);
    }
    public async recalcularCuotasByMovement(idCreditProcessMovement: number): Promise<any> {
        return this.getCustomService("CreditCore", "void_recalcularCuotasByMovement_Number", [
            idCreditProcessMovement
        ]);
    }
    public async deleteCreditProcessItem(id): Promise<any> {
        return this.getCustomService("CreditCore", "boolean_deleteCreditProcessItem_Number", [
            id
        ]);
    }
    public async updateCreditProcessItem(bean: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.credit.bean.CreditProcessItem_updateCreditProcessItem_com.credit.bean.CreditProcessItem", [
            {
                DataBeanProperties: bean,
                DataBeanName: "com.credit.bean.CreditProcessItem"
            }
        ]);
    }
    public async getCreditProcessItemWhitPaymentRender(page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getCreditProcessItemWhitPaymentRender_Number_Number_java.util.Map", [
            page, rows, props
        ]);
    }


}
